getVariables